import { render, staticRenderFns } from "./DayRedpack.vue?vue&type=template&id=ff4f7df0&scoped=true&"
import script from "./DayRedpack.vue?vue&type=script&lang=js&"
export * from "./DayRedpack.vue?vue&type=script&lang=js&"
import style0 from "./DayRedpack.vue?vue&type=style&index=0&id=ff4f7df0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4f7df0",
  null
  
)

export default component.exports